import Cookies from 'js-cookie';
import { cookieName } from 'config'

export default async function () {
    try {
        const auth = Cookies.get(cookieName);

        return auth || null;
    } catch {
        return null;
    }
}
